import React, { useEffect, useRef } from 'react';
import './InstagramSection.css';
import { FaPlay } from 'react-icons/fa';
import { Trans, useTranslation } from 'react-i18next'; // Importar hooks


import img1 from '../../../assets/ig-1.jpg';
import img2 from '../../../assets/ig-2.jpg';
import img3 from '../../../assets/ig-3.jpg';
import img4 from '../../../assets/ig-4.jpg';
import img5 from '../../../assets/ig-5.jpg';
import img6 from '../../../assets/ig-6.jpg';
import img7 from '../../../assets/ig-7.jpg';
import img8 from '../../../assets/ig-8.jpg';

interface MediaItem {
  id: number;
  type: 'video' | 'image';
  image: string;
  link: string;
}

const mediaData: MediaItem[] = [
  { id: 1, type: 'video', image: img1, link: 'https://www.instagram.com/p/DOE9tC6Dbuz/' },
  { id: 2, type: 'video', image: img2, link: 'https://www.instagram.com/p/DNyrfqmQi9x/' },
  { id: 3, type: 'video', image: img3, link: 'https://www.instagram.com/p/DNhI72EOG25/' },
  { id: 4, type: 'video', image: img4, link: 'https://www.instagram.com/p/DMvJzIWuNOF/' },
  { id: 5, type: 'video', image: img5, link: 'https://www.instagram.com/p/DMYzP7juVYc/' },
  { id: 6, type: 'video', image: img6, link: 'https://www.instagram.com/p/DJ2x6pDO3ku/' },
  { id: 7, type: 'video', image: img7, link: 'https://www.instagram.com/p/DMG_hEIOEFn/' },
  { id: 8, type: 'video', image: img8, link: 'https://www.instagram.com/p/DLh98ZSiNFb/' },
];

const InstagramSection: React.FC = () => {
  useTranslation(); 
  
  const sectionRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const elements = sectionRef.current?.querySelectorAll('.grid-item');
    if (!elements) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const el = entry.target as HTMLElement;
          if (entry.isIntersecting) {
            el.classList.add('visible');
            el.style.animation = 'fadeInUp 0.7s ease-out forwards';
          } else {
            el.classList.remove('visible');
            el.style.animation = 'none';
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="instagram-section" ref={sectionRef}>
      <div className="instagram-title-container">
        <span className="instagram-title-main">
          {/* 2. Traducción del título */}
          <Trans i18nKey="instagram:followUs" />
        </span>
        <span className="instagram-title-handle">
          {/* 3. Traducción del handle (opcional, pero buena práctica) */}
          <Trans i18nKey="instagram:handle" />
        </span>
      </div>

      <div className="instagram-grid">
        {mediaData.map((media) => (
          <a
            href={media.link}
            key={media.id}
            className="grid-item"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={media.image} alt={`Instagram post ${media.id}`} className="grid-image" />
            <div className="grid-item-overlay">
              {media.type === 'video' && <FaPlay className="play-icon" />}
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};

export default InstagramSection;